namespace $.$$ {

	$mol_style_define( $shm_hitalama_entergate, {

		flex: {
			grow: 1,
		},

		minHeight: '100%',

		align: {
			items: 'center',
		},

		justify: {
			content: 'center',
		},

		padding: $mol_gap.block,

		background: {
			color: $mol_theme.back,
		},

		Form: {

			flex: {
				direction: 'column',
			},

			width: '36rem',
			maxWidth: '100%',

			padding: $mol_gap.block,

			gap: $mol_gap.block,

			align: {
				items: 'stretch',
			},

			background: {
				color: $mol_theme.card,
			},

			border: {
				radius: $mol_gap.round,
			},

			box: {
				shadow: [{
					x: 0,
					y: 0,
					blur: 0,
					spread: '1px',
					color: $mol_theme.line,
				}],
			},

			Title: {
				font: {
					size: '1.5rem',
					weight: 600,
				},
				margin: 0,
			},

			Mode_tabs: {
				flex: {
					direction: 'row',
				},
				gap: $mol_gap.text,
			},

			Enter_tab: {
				flex: {
					grow: 1,
				},
				justify: {
					content: 'center',
				},
			},

			Register_tab: {
				flex: {
					grow: 1,
				},
				justify: {
					content: 'center',
				},
			},

			Access_label: {
				Content: {
					align: {
						self: 'stretch',
					},
				},
			},

			Secret_label: {
				Content: {
					align: {
						self: 'stretch',
					},
				},
			},

			Login_label: {
				Content: {
					align: {
						self: 'stretch',
					},
				},
			},

			Mode_field: {
				flex: {
					direction: 'column',
				},
			},

			Access_token: {
				width: '100%',
			},

			Secret_key: {
				width: '100%',
			},

			Login: {
				width: '100%',
			},

			Actions: {
				flex: {
					direction: 'column',
				},
				gap: $mol_gap.text,
			},

			Submit: {
				flex: {
					grow: 1,
				},
			},

			Message: {
				minHeight: '1.5rem',
				color: $mol_theme.special,
			},

			Saved_label: {
				flex: { grow: 1, shrink: 1 },
			},

		},

	} )

}
